import { Action, createReducer, on } from '@ngrx/store';
import * as fromReprocessPayment from '../actions';
import { IReprocessPaymentResponse } from '../dto/pyament-run.dto';

export const paymentReprocessorFeatureKey = 'paymentReprocessor';

export interface State {
  loaded: boolean;
  error?: Error | any;
  paymentReprocess: IReprocessPaymentResponse;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  paymentReprocess: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromReprocessPayment.loadPaymentReprocesss, state => state),
  on(fromReprocessPayment.loadPaymentReprocesssSuccess, (state, action) => ({
    ...state,
    paymentReprocess: action.response,
    loaded: true
  })),
  on(fromReprocessPayment.loadPaymentReprocesssFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectReprocessPayment = (state: State) => state.paymentReprocess;
export const selectReprocessPaymentLoaded = (state: State) => state.loaded;
export const selectReprocessPaymentError = (state: State) => state.error;
